import Modal from 'developer_components/newModal';
import {isMobile} from 'methods/utils';

function SearchModal() {
    this.$element = Modal.createFromHTML(
        `<div class="Modal-native__header">
            <div class="Modal-native__header-title">Быстрый поиск</div>
            <div class="Modal-native__close"></div>
        </div>
        <div class="Modal-native__content">
            <form class="js-filterForm search-v2 search-v2--top-search js-topSearchModal">
                <div class="search-v2-container">
                    <div class="search search-wrapper js-searchWrapper">
                        <div class="search-container">
                            <div class="search-item">
                                <div class="search-label">Курорт или отель</div>

                                <div class="search-input-wrapper">
                                    <div class="search-preview is-hidden js-searchPreview">
                                        <span class="first-part js-firstPart"></span>
                                        <span class="second-part js-secondPart"></span>
                                    </div>
                                    <input class="search-input js-searchInput" name="search_input" type="text" value="" placeholder="Где хотите отдохнуть?" autocomplete="off" />
                                </div>

                                <div class="search-reset js-searhCross is-hidden">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#D4D2D8"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="error-item js-searchErrorItem">
                                <p class="error-title js-searchErrorTitle"></p>
                            </div>
                        </div>
                    </div>

                    <div class="date-wrapper js-dateRangePicker">
                        <div class="date-container">
                            <div class="date-item">
                                <input type="hidden" name="date_start" value="">
                                <div class="date-label">Заезд</div>
                                <div class="date-input date-input--muted" data-name="date_start">Дата</div>
                            </div>
                            <div class="date-item">
                                <input type="hidden" name="date_finish" value="">
                                <div class="date-label">Выезд</div>
                                <div class="date-input date-input--muted" data-name="date_finish">Дата</div>
                                <div class="date-reset is-hidden js-rangeReset">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#D4D2D8"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="people-wrapper js-peoplePicker">
                        <div class="people-container">
                            <div class="people-item">
                                <div class="people-label">Количество гостей</div>
                                <div class="people-input people-input--muted" data-title="total">Кто поедет?</div>
                            </div>
                        </div>
                    </div>
                </div>

                ${
                    isMobile() ?
                    `<button class="search-button js-searchButton"><span>Найти</span></button>` :
                    `<div class="button-wrapper">
                        <button class="search-button js-searchButton"><span>Найти</span></button>
                    </div>`
                }
            </form>
        </div>`,
        {
            id: 'search-modal',
        }
    );

    // наследование
    Modal.call(this, this.$element);
}

SearchModal.prototype = Object.create(Modal.prototype)
Object.defineProperty(SearchModal, 'constructor', {
    value: SearchModal,
    enumerable: false,
    writable: true,
});

export default SearchModal;
